import { BadgeCheck } from 'lucide-react';
import clsx from 'clsx';

interface VerifiedBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

/**
 * Blue "verified" tick. Shown next to a user's name when isUserVerified()
 * returns true. Sticks to a single look (filled blue badge with a white tick)
 * across the back-office so it reads the same in tables and on detail pages.
 */
export function VerifiedBadge({
  size = 'md',
  label,
  className,
}: VerifiedBadgeProps) {
  const px = size === 'sm' ? 14 : size === 'lg' ? 22 : 18;
  return (
    <span
      title={label ?? 'Verified user'}
      aria-label={label ?? 'Verified user'}
      className={clsx('inline-flex items-center text-sky-500', className)}
    >
      <BadgeCheck
        size={px}
        fill="currentColor"
        className="text-sky-500"
        strokeWidth={1.75}
        stroke="#ffffff"
      />
    </span>
  );
}
